<template>
  <div class="shop-screen history-screen">
    <header class="history-header">
      <h1>{{ $t('shop.orderHistory') }}</h1>
    </header>
    <nav class="tabs">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        :class="{ active: status === tab.value }"
        @click="switchStatus(tab.value)"
      >
        {{ tab.label }}
      </button>
    </nav>
    <main>
      <article
        v-for="order in list"
        :key="order.id"
        class="order-card"
      >
        <div class="order-meta">
          <span>{{ shortOrderNo(order.order_no) }}</span><time>{{ order.created_at }}</time>
        </div>
        <div
          v-for="item in order.items"
          :key="item.id"
          class="order-item"
          @click="details(order.id)"
        >
          <img
            :src="item.image"
            :alt="item.title"
          >
          <div>
            <p>{{ item.title }}</p>
            <strong>{{ money(item.unit_price) }}</strong> <span>x{{ item.quantity }}</span>
            <small>{{ state(order) }}</small>
          </div>
        </div>
        <div class="order-actions">
          <button
            v-if="order.status === 'pending'"
            @click="pay(order.id)"
          >
            {{ $t('shop.pay') }}
          </button>
          <button
            v-if="order.status === 'pending'"
            @click="cancel(order.id)"
          >
            {{ $t('shop.cancel') }}
          </button>
          <button @click="details(order.id)">
            {{ $t('shop.details') }}
          </button>
        </div>
      </article>
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
    </main>
  </div>
</template>

<script>
import Fetch from '@/utils/fetch';
import Vue from 'vue';
import { Empty } from 'vant';

Vue.use(Empty);

export default {
    data() {
        return {
            status: '', list: [], loading: false, empty: false,
            tabs: [
                { value: '', label: this.$t('shop.all') },
                { value: 'pending', label: this.$t('shop.pending') },
                { value: 'paid', label: this.$t('shop.paid') },
                { value: 'repurchased', label: this.$t('shop.repurchase') },
                { value: 'cancelled', label: this.$t('shop.cancel') }
            ]
        };
    },
    mounted() {
        this.$parent.footer('orderhis');
        this.load();
    },
    methods: {
        money(value) {
            return this.$formatPen(value);
        },
        shortOrderNo(value) {
            const orderNo = String(value || '');
            return orderNo.length > 13 ? orderNo.slice(0, 8) + orderNo.slice(-5) : orderNo;
        },
        load() {
            this.loading = true;
            Fetch('/shop/orderList', { status: this.status, page: 1, page_size: 30 }, null, true).then((res) => {
                this.list = res.data.list || [];
                this.empty = this.list.length === 0;
            }).finally(() => {
                this.loading = false;
            });
        },
        switchStatus(status) {
            if (this.status === status) return;
            this.status = status;
            this.load();
        },
        details(id) {
            this.$router.push('/shopOrder/' + id);
        },
        pay(id) {
            Fetch('/shop/orderPay', { order_id: id }, null, true).then(() => this.load());
        },
        cancel(id) {
            Fetch('/shop/orderCancel', { order_id: id }, null, true).then(() => this.load());
        },
        state(order) {
            const states = {
                pending: this.$t('shop.pending'),
                paid: this.$t('shop.paid'),
                repurchased: this.$t('shop.repurchase'),
                cancelled: this.$t('shop.cancel')
            };
            return this.$t('shop.state') + ' ' + states[order.status];
        }
    }
};
</script>

<style scoped>
.shop-screen { min-height: 100vh; background: #f5f5f5; padding-bottom: calc(var(--app-bottom-menu-height) + var(--app-bottom-menu-gap) + env(safe-area-inset-bottom, 0px)); color: #333; }
.history-header { display: flex; height: 50px; align-items: center; justify-content: center; background: #fff; border-bottom: 1px solid #eee; }
.history-header h1 { margin: 0; color: #333; font-size: 16px; font-weight: 500; }
.tabs { display: flex; height: 48px; justify-content: space-around; align-items: stretch; background: #fff; }
.tabs button { position: relative; flex: 1; border: 0; background: #fff; color: #777; font-size: 12px; white-space: nowrap; }
.tabs .active { color: #ee4d2d; font-weight: 600; }
.tabs .active::after { position: absolute; bottom: 0; left: 25%; width: 50%; height: 3px; border-radius: 3px; background: #ee4d2d; content: ''; }
.order-card { margin-bottom: 10px; background: #fff; }
.order-meta { display: flex; justify-content: space-between; padding: 12px 14px; border-bottom: 1px solid #eee; color: #555; font-size: 11px; }
.order-meta time { color: #939aa3; }
.order-item { display: flex; min-height: 96px; gap: 12px; align-items: center; padding: 10px 14px; }
.order-item img { width: 78px; height: 78px; object-fit: contain; }
.order-item > div { min-width: 0;line-height: 25px;}
.order-item p { display: -webkit-box; margin: 0 0 4px; overflow: hidden; font-size: 12px; line-height: 16px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.order-item strong { color: #ee4d2d; font-size: 14px; }
.order-item span { margin-left: 5px; color: #777; font-size: 12px; }
.order-item small { display: block; color: #888; font-size: 12px; }
.order-actions { display: flex; min-height: 52px; justify-content: flex-end; gap: 8px; align-items: center; padding: 0 14px; border-top: 1px solid #eee; }
.order-actions button { min-width: 72px; min-height: 30px; border: 1px solid #ddd; border-radius: 4px; background: #fff; color: #555; font-size: 12px; }
.order-actions button:first-child { border-color: #ee4d2d; color: #ee4d2d; }
</style>
